/* 
  Crower Shopify Theme - Theme JS
  Interactivity for slider, mobile menu, tabs, etc.
*/

document.addEventListener('DOMContentLoaded', () => {
  initHeroSlider();
  initMobileMenu();
  initLocationsTabs();
  initCategoryScroll();
  initCollectionFilters();
  initProductVariants();
  initCartDrawer();
  initAjaxAdd();
});

/**
 * Hero Slider Interactivity
 */
function initHeroSlider() {
  const sliders = document.querySelectorAll('.hero-slider');
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.hero-slide');
    const dots = slider.querySelectorAll('.hero-dot');
    const prevBtn = slider.querySelector('.hero-prev');
    const nextBtn = slider.querySelector('.hero-next');
    
    let currentSlide = 0;
    const slideCount = slides.length;
    let interval;

    const goToSlide = (index) => {
      slides.forEach(s => s.classList.remove('active'));
      dots.forEach(d => d.classList.remove('active'));
      
      slides[index].classList.add('active');
      dots[index].classList.add('active');
      currentSlide = index;
    };

    const nextSlide = () => {
      let next = (currentSlide + 1) % slideCount;
      goToSlide(next);
    };

    const prevSlide = () => {
      let prev = (currentSlide - 1 + slideCount) % slideCount;
      goToSlide(prev);
    };

    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    
    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        goToSlide(idx);
        resetInterval();
      });
    });

    const resetInterval = () => {
      clearInterval(interval);
      interval = setInterval(nextSlide, 5000);
    };

    resetInterval();
  });
}

/**
 * Mobile Menu Toggle
 */
function initMobileMenu() {
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const menuSheet = document.querySelector('.mobile-menu-sheet');
  const menuClose = document.querySelector('.mobile-menu-close');
  const overlay = document.querySelector('.menu-overlay');

  if (!menuToggle || !menuSheet) return;

  const openMenu = () => {
    menuSheet.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    menuSheet.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
}

/**
 * Locations City Tabs
 */
function initLocationsTabs() {
  const tabButtons = document.querySelectorAll('.location-tab-btn');
  const locationPanels = document.querySelectorAll('.location-panel');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const cityId = btn.dataset.city;
      
      tabButtons.forEach(b => b.classList.remove('active'));
      locationPanels.forEach(p => p.classList.remove('active'));
      
      btn.classList.add('active');
      const targetPanel = document.querySelector(`.location-panel[data-city="${cityId}"]`);
      if (targetPanel) targetPanel.classList.add('active');
    });
  });
}

/**
 * Horizontal Category Scroll
 */
function initCategoryScroll() {
  const container = document.querySelector('.categories-scroll-container');
  const prevBtn = document.querySelector('.categories-scroll-prev');
  const nextBtn = document.querySelector('.categories-scroll-next');

  if (!container) return;

  const scrollAmount = 200;

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
}

/**
 * Collection Filters Drawer
 */
function initCollectionFilters() {
  const trigger = document.querySelector('.mobile-filter-trigger');
  const drawer = document.querySelector('.filter-drawer');
  const overlay = document.querySelector('.filter-overlay');
  const closeBtns = document.querySelectorAll('.mobile-filter-close');

  if (!trigger || !drawer || !overlay) return;

  const openDrawer = () => {
    drawer.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  trigger.addEventListener('click', openDrawer);
  overlay.addEventListener('click', closeDrawer);
  closeBtns.forEach(btn => btn.addEventListener('click', closeDrawer));

  // Auto-submit price range on enter
  const priceInputs = drawer.querySelectorAll('.price-range-inputs input');
  priceInputs.forEach(input => {
    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        input.closest('form').submit();
      }
    });
  });
}

/**
 * Product Variant Selection
 */
function initProductVariants() {
  const container = document.querySelector('.product-main-grid');
  if (!container) return;

  const sectionId = container.dataset.sectionId;
  const variants = JSON.parse(container.dataset.productVariants || container.dataset.product_variants || '[]');
  const variantSelectors = container.querySelectorAll('.variant-btn, .variant-swatch');
  const variantIdInput = document.getElementById(`ProductVariantId-${sectionId}`);
  const priceEle = document.getElementById(`ProductPrice-${sectionId}`);
  const comparePriceEle = document.getElementById(`ComparePrice-${sectionId}`);
  const mainImage = document.getElementById(`MainProductImage-${sectionId}`);

  if (!variantSelectors.length || !variantIdInput) return;

  const updateVariant = () => {
    const selectedOptions = [];
    container.querySelectorAll('.variant-option-group').forEach(group => {
      const activeBtn = group.querySelector('.variant-btn.active, .variant-swatch.active');
      if (activeBtn) selectedOptions.push(activeBtn.dataset.value);
    });

    const matchedVariant = variants.find(v => {
      return v.options.every((opt, idx) => opt === selectedOptions[idx]);
    });

    if (matchedVariant) {
      variantIdInput.value = matchedVariant.id;
      
      // Update Price
      if (priceEle) priceEle.textContent = formatMoney(matchedVariant.price);
      if (comparePriceEle) {
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          comparePriceEle.textContent = formatMoney(matchedVariant.compare_at_price);
          comparePriceEle.style.display = 'inline';
        } else {
          comparePriceEle.style.display = 'none';
        }
      }

      // Update Image
      if (matchedVariant.featured_image && mainImage) {
        mainImage.src = matchedVariant.featured_image.src;
      }
      
      // Update Add to Cart Button
      const addToCartBtn = container.querySelector('button[type="submit"]');
      if (addToCartBtn) {
        addToCartBtn.disabled = !matchedVariant.available;
        addToCartBtn.textContent = matchedVariant.available ? 'AÑADIR A LA BOLSA' : 'AGOTADO';
        
        if (matchedVariant.available) {
          addToCartBtn.style.background = '#111';
          addToCartBtn.style.color = 'white';
          addToCartBtn.style.borderColor = '#111';
          addToCartBtn.style.cursor = 'pointer';
        } else {
          addToCartBtn.style.background = '#f5f5f5';
          addToCartBtn.style.color = '#999';
          addToCartBtn.style.borderColor = '#eee';
          addToCartBtn.style.cursor = 'not-allowed';
        }
      }
    }
  };

  variantSelectors.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-option-group');
      group.querySelectorAll('.variant-btn, .variant-swatch').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      updateVariant();
    });
  });
}

/**
 * Cart Drawer Logic
 * Nota: el input de cantidad debe resolverse dentro de .cart-qty-wrapper.
 * Usar .closest('.flex') rompía el carrito: coincidía con el aside del drawer
 * y siempre leía el primer .cart-qty-input de la lista.
 */
const cartLinePending = new Set();
let themeToastTimer = null;

function hideThemeToast() {
  const el = document.getElementById('ThemeToast');
  if (!el) return;
  el.classList.remove('theme-toast--visible');
  clearTimeout(themeToastTimer);
  themeToastTimer = null;
  window.setTimeout(() => {
    el.setAttribute('hidden', '');
  }, 280);
}

/**
 * Aviso no bloqueante (stock, errores de carrito) — reemplaza window.alert
 * @param {string} message
 * @param {{ variant?: 'warning'|'error', duration?: number }} [options]
 */
function showThemeToast(message, options = {}) {
  if (!message || typeof message !== 'string') return;
  const el = document.getElementById('ThemeToast');
  if (!el) return;

  const msgEl = el.querySelector('.theme-toast__message');
  if (msgEl) msgEl.textContent = message;

  el.classList.remove('theme-toast--warning', 'theme-toast--error');
  el.classList.add(options.variant === 'error' ? 'theme-toast--error' : 'theme-toast--warning');

  clearTimeout(themeToastTimer);
  el.removeAttribute('hidden');
  requestAnimationFrame(() => {
    el.classList.add('theme-toast--visible');
  });

  const duration = typeof options.duration === 'number' ? options.duration : 9000;
  themeToastTimer = window.setTimeout(hideThemeToast, duration);

  const closeBtn = el.querySelector('.theme-toast__close');
  if (closeBtn) {
    closeBtn.onclick = (ev) => {
      ev.preventDefault();
      hideThemeToast();
    };
  }
}

function findCartQtyWrapper(key) {
  const nodes = document.querySelectorAll('[data-line-key]');
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].getAttribute('data-line-key') === key) return nodes[i];
  }
  return null;
}

function setCartLineBusy(key, busy) {
  const wrap = findCartQtyWrapper(key);
  if (!wrap) return;
  wrap.querySelectorAll('.cart-qty-btn, .cart-qty-input').forEach((el) => {
    el.disabled = busy;
  });
  wrap.classList.toggle('cart-qty-wrapper--busy', busy);
}

function initCartDrawer() {
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer-overlay');
  
  if (!drawer || !overlay) return;

  window.openCartDrawer = () => {
    drawer.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = () => {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  overlay.addEventListener('click', window.closeCartDrawer);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.cart-drawer-close')) {
      e.preventDefault();
      window.closeCartDrawer();
    }
    
    if (e.target.closest('.cart-item-remove')) {
      const removeBtn = e.target.closest('.cart-item-remove');
      const key = removeBtn.dataset.key;
      if (key) updateCartItem(key, 0);
    }

    const qtyBtn = e.target.closest('.cart-qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.dataset.key;
      if (!key || cartLinePending.has(key)) return;

      const wrapper = qtyBtn.closest('.cart-qty-wrapper');
      const input = wrapper && wrapper.querySelector('.cart-qty-input');
      if (!input) return;

      let qty = parseInt(input.value, 10);
      if (Number.isNaN(qty)) qty = 0;

      if (qtyBtn.dataset.action === 'plus') qty += 1;
      else if (qtyBtn.dataset.action === 'minus') qty -= 1;

      if (qty < 0) return;

      updateCartItem(key, qty);
    }
  });
}

async function refreshCartDrawer() {
  try {
    const res = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
    const text = await res.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    
    const newContent = html.getElementById('CartDrawer-Content');
    const currentContent = document.getElementById('CartDrawer-Content');
    if (newContent && currentContent) currentContent.innerHTML = newContent.innerHTML;

    const newCount = html.getElementById('CartDrawer-Count');
    const countPills = document.querySelectorAll('.cart-count');
    if (newCount) countPills.forEach(pill => pill.textContent = newCount.textContent);
  } catch (err) {
    console.error('Failed to refresh cart', err);
  }
}

async function updateCartItem(key, quantity) {
  if (!window.routes || !window.routes.cart_change_url) {
    console.error('Cart routes not available');
    return;
  }
  if (cartLinePending.has(key)) return;
  cartLinePending.add(key);
  setCartLineBusy(key, true);

  try {
    const res = await fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    });
    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      const msg =
        data.description ||
        data.message ||
        (data.errors && String(data.errors)) ||
        'No se pudo actualizar la cantidad.';
      console.error('Cart change failed', data);
      showThemeToast(msg, { variant: 'warning' });
    }
    await refreshCartDrawer();
  } catch (err) {
    console.error(err);
    showThemeToast('Error de conexión al actualizar el carrito.', { variant: 'error' });
    await refreshCartDrawer();
  } finally {
    cartLinePending.delete(key);
    setCartLineBusy(key, false);
  }
}

function initAjaxAdd() {
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  productForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      // Allow dynamic checkout buttons to submit natively
      if (e.submitter && !e.submitter.classList.contains('add-to-cart-btn')) {
        return;
      }
      
      e.preventDefault();
      const submitBtn = form.querySelector('.add-to-cart-btn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'AGREGANDO...';
      }

      // Shopify cart API requires JSON, not multipart/form-data
      const formData = new FormData(form);
      const data = {};
      formData.forEach((value, key) => { data[key] = value; });

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status && json.status >= 400) {
          throw new Error(json.description);
        }
        return refreshCartDrawer();
      })
      .then(() => {
        if (window.openCartDrawer) window.openCartDrawer();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'AGREGAR A CARRITO';
        }
      })
      .catch((err) => {
        console.error('Add to cart failed', err);
        showThemeToast(
          'No se pudo agregar el producto: ' + (err.message || 'intenta de nuevo.'),
          { variant: 'error' }
        );
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'AGREGAR A CARRITO';
        }
      });
    });
  });
}

/**
 * Simple Money Formatter
 */
function formatMoney(cents) {
  return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
}
